export default __webpack_public_path__ + "assets/audios/2c6f791e9565ea994ab6f85186d6774a.mp3";